import { makeStyles, shorthands } from '@fluentui/react-components';

export const useNotificationRuleMatrixStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  matrix: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: 'minmax(100px, 1fr) repeat(6, 60px) 100px',
    alignItems: 'center',
    gap: '8px',
    ...shorthands.padding('8px'),
    backgroundColor: 'var(--colorNeutralBackground3)',
    borderRadius: '4px',
  },
  headerRow: {
    fontWeight: 600,
    backgroundColor: 'var(--colorNeutralBackground1)',
  },
  headerCell: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    textAlign: 'center',
  },
  severity: {
    fontSize: '12px',
    fontWeight: 500,
  },
  checkbox: {
    display: 'flex',
    justifyContent: 'center',
  },
  fieldWithInfo: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  fieldHeaderWithInfo: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  infoIconWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'help',
  },
  infoIcon: {
    color: 'var(--colorNeutralForeground3)',
    fontSize: '14px',
  },
  groupList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  groupItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '12px',
  },
  groupLabel: {
    flex: 1,
  },
  smallButton: {
    minWidth: '24px',
    height: '24px',
  },
  mobileCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    ...shorthands.padding('12px'),
    backgroundColor: 'var(--colorNeutralBackground1)',
    ...shorthands.border('1px', 'solid', 'var(--colorNeutralStroke2)'),
    borderRadius: '8px',
  },
  mobileCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    cursor: 'pointer',
  },
  mobileCardSummary: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: 1,
    color: 'var(--colorNeutralForeground3)',
  },
  mobileCardChevronWrap: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
  },
  mobileExpandedCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    ...shorthands.padding('8px'),
    backgroundColor: 'var(--colorNeutralBackground2)',
    borderRadius: '6px',
  },
  mobileSwitchGrid: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  mobileSwitchRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
});
